export default "__VITE_ASSET__4a039674__"